import { IApp03Task } from "./App03Task";
import { IApp03Template } from "./App03Template";
import { Entity, IEntity } from "./Entity";

export interface IApp03WorkItemType extends IEntity {
    Description?: string;
    App03TemplateID?: number;
    SystemType?: string;
    IsDefault?: boolean;
    CreatedByID?: number;
    CreatedOn?: Date;
    ModifiedByUserID?: number;
    ModifiedOn?: Date;
    App03Template?: IApp03Template;
    App03Tasks?: IApp03Task[];

}

export class App03WorkItemType extends Entity implements IApp03WorkItemType {
    public Description = null;
    public App03TemplateID = null;
    public SystemType = null;
    public IsDefault = false; //default value
    public CreatedByID = null;
    public CreatedOn = null;
    public ModifiedByUserID = null;
    public ModifiedOn = null;

    public App03Template = null;
    public App03Tasks = [];

    constructor() {
        super();
    }
}

export const App03WorkItemSystemTypes = {
    PrimaryItem: "Primary Item ",
    GeneralItem: "General Item",
    ResolveDefect: "Resolve Defect",
    Research: "Research ",
    ChangeRequest: "Change Request",
} as const;